var isWebpSupport = 'chrome' in window &&
    window.navigator.userAgent.match(/firefox|iceweasel|fxios|edge|msie|trident/i) === null;
var isHeifSupport = false;

var imgRoute = function imgRoute (params, previousRequest) {
    var dir = params.dir;
    var name = params.name;
    var ext = params.ext;
    var query = params.query || '';

    var screenW = window.screen.width;
    var screenH = window.screen.height;

    if (dir.indexOf('/c11n/') !== -1 && !fox.c11nImageOptimized) {
        return previousRequest;
    }

    if (query.indexOf('skipTransform') === -1) {
        if (screenW <= 800) {
            name += '_mobile';
        } else if (screenW <= 1280) {
            name += '_tablet';
        }
    }

    if (isWebpSupport) {
        ext = '.webp';
    } else if (isHeifSupport) {
        ext = '.heic';
    }

    return [dir, name, ext].join('');
};

var master = null;

if ('fox' in window && !fox._r.patched) {
    master = fox._r;

    fox._r = function fox_r (alias, path, isFallback) {
        var masterRes = master(alias, path);

        if (!isFallback || !fox.c11nImageOptimized) {
            return masterRes;
        }

        var fullPath = masterRes;

        if (!fullPath) return '';

        var tmp = fullPath.split('/');
        var dir = tmp.slice(0, -1).join('/') + '/';
        
        tmp = tmp.slice(-1)[0].split('.');
        var ext = '.' + tmp.slice(-1)[0];
        var name = tmp.slice(0, -1).join('.');

        return imgRoute({
            dir: dir,
            name: name,
            ext: ext
        }, fullPath);
    }

    fox._r.patched = true;
}

module.exports = exports = imgRoute;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-image-optimize-plugin/lib/imageRouterFox.js
// module id = 207
// module chunks = 4